import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * Sidebar para lista de memberships (Planos) do NeoApp
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const MembershipSidebar = ({ memberships = [], activeId, onSelect, onCreateNew, loading }) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar memberships baseado na pesquisa local
    const filteredMemberships = memberships.filter((membership) =>
        membership.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear memberships para o formato padrão do NeoSideMenu
    const sideMenuItems = filteredMemberships.map((membership) => {
        const durationText = `${membership.duration} ${
            membership.durationType === 'monthly' ? 'mês(es)' :
            membership.durationType === 'yearly' ? 'ano(s)' :
            membership.durationType === 'classes' ? 'aula(s)' : 'dia(s)'
        }`;
        const typeText = membership.type === 'recurrent' ? 'Recorrente' : membership.type === 'fixed' ? 'Fixo' : 'Passe';

        return {
            id: membership.id,
            label: membership.name,
            description: `${typeText} • ${durationText}`,
            icon: "mdi-file-document-outline",
            badge: membership.status === GLOBAL_STATUS.INACTIVE ? "Inativo" : null,
            badgeVariant: membership.status === GLOBAL_STATUS.INACTIVE ? "muted" : null
        };
    });

    return (
        <NeoSideMenu
            title="Planos"
            subtitle="Configuração de Associação"
            icon="mdi-file-document-outline"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const membership = memberships.find((m) => m.id === id);
                if (membership) onSelect(membership);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar plano..."
                />
            }
        />
    );
};

MembershipSidebar.propTypes = {
    memberships: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    onReorder: PropTypes.func
};

export default MembershipSidebar;
